<template>
  <div class="c-study-topic">
    <div class="c-study-topic-content" v-if="!loading">
      <p class="c-study-topic-fraction" v-if="hasDone">
        <span class="green">得分</span>
        <span class="green big">{{fraction}}</span>
        <span>/{{total}}</span>
      </p>
      <p v-if="selects.length" class="c-study-topic-title">单选题</p>
      <Select :trigger="trigger" :selects="selects"/>
      <p v-if="fills.length" class="c-study-topic-title">填空题</p>
      <Fill :trigger="trigger" :fills="fills"/>
      <p v-if="judges.length" class="c-study-topic-title">判断题</p>
      <Judge :trigger="trigger" :judges="judges"/>
      <button @click="fire" v-if="!(+this.current.exstatus) && !hasDone">提交</button>
    </div>
    <Loading v-if="loading" class="c-study-topic-loading" />
  </div>
</template>

<script>
import Select from './select'
import Fill from './fill'
import Judge from './judge'
import Loading from '@/components/loading'
import { Message } from 'element-ui'

import api from '@/api/index'

export default {
  components: {
    Select,
    Fill,
    Judge,
    Loading
  },
  props: {
    current: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      trigger: false,
      fraction: 0,
      selects: [],
      fills: [],
      judges: [],
      loading: true,
      hasDone: false,
      total: 0
    }
  },
  methods: {
    async fire () {
      if (!(+this.current.exstatus)) {
        let score = await this.sendAnswers()
        if (score.data && Number.isInteger(score.data.actsc) || score == 'false') {
          this.$emit('finishExstatus')
          this.hasDone = true
        }
      } else {
        this.showAnswers()
      }
    },
    showAnswers () {
      this.trigger = true
      let topics = this.selects.concat(this.fills).concat(this.judges)
      topics.forEach((v) => {
        let answer
        let ansList = 'ABCD'
        if (v.type == '0' || v.type == '3') {
          answer = ansList[v.userAnswer]
        } else {
          answer = v.userAnswer
        }
        if (v.answer == answer) {
          this.fraction += parseInt(v.course)
        }
      })
    },
    async sendAnswers () {
      return new Promise(async(resolve) => {
        let ansList = 'ABCD'
        let answer = ''
        let finished = true
        let unfinished = []
        const target = document.querySelector(".e-study-topic") || document.querySelector("html")
        target.scrollTop = 0
        let topics = this.selects.concat(this.fills).concat(this.judges)
        let submitAnswer = topics.map((v) => {
          if (!v.userAnswer || v.userAnswer === '请输入答案') {
            finished = false
            unfinished.push(v)
          }
          if (v.type == '0' || v.type == '3') {
            answer = ansList[v.userAnswer]
          } else {
            answer = v.userAnswer
          }
          return `${v.itemid}:${answer || null}`
        })
        if (finished) {
          this.trigger = true;
          if (!this.hasDone) {
            // ${this.$route.params.id}
            // this.current.chapterIndex + 1
            // this.$route.params.id
            let response
            response = await api.sendAnswer(+this.current.chapterIndex + 1, this.$route.params.id, submitAnswer.join(';'))
            resolve(response)
          }
        } else {
          Message({
            message: '还有题目没有完成，请完成后再提交！',
            type: 'error'
          })
        }
      })
    },
    async mapTopics () {
      if (Number.isInteger(+this.current.chapterIndex)) {
        this.loading = true
        this.hasDone = false
        this.selects = []
        this.fills = []
        this.judges = []
        this.trigger = false
        this.fraction = 0
        this.total = 0
        let response
        response = await api.getTopics(+this.current.chapterIndex + 1, this.$route.params.id)
        let topics = response.data
        if (!(+this.current.exstatus) && !(topics[0].reanswer === false)) {
          // 如果题目没做过
          topics.forEach((v) => {
            this.total += parseInt(v.course)
            // 类型type: 0选择 1填空 3判断
            // 状态state: 0未完成 1已完成 2已批阅
            v.state = '0'
            v.userAnswer = null
            if (v.type == '0') {
              v.chooses = [v.ans_a, v.ans_b, v.ans_c, v.ans_d]
              this.selects.push(v)
            } else if (v.type == '1') {
              this.fills.push(v)
              v.userAnswer = '请输入答案'
            } else if (v.type == '3') {
              v.chooses = [true, false]
              this.judges.push(v)
            } else {
              throw new Error(`unkonwType: ${v.type}, data: ${v}`)
            }
          })
          this.loading = false
        } else {
          // 如果题目做过了
          this.hasDone = true
          let ansList = {
            A: '0',
            B: '1',
            C: '2',
            D: '3'
          }
          topics.forEach((v) => {
            this.total += parseInt(v.course)
            // 类型type: 0选择 1填空 3判断
            // 状态state: 0未完成 1已完成 2已批阅
            v.state = '0'
            v.userAnswer = null
            if (v.type == '0') {
              v.chooses = [v.ans_a, v.ans_b, v.ans_c, v.ans_d]
              v.userAnswer = ansList[v.reanswer]
              this.selects.push(v)
            } else if (v.type == '1') {
              this.fills.push(v)
              v.userAnswer = v.reanswer || '未填写答案'
            } else if (v.type == '3') {
              v.chooses = [true, false]
              v.userAnswer = ansList[v.reanswer]
              this.judges.push(v)
            } else {
              throw new Error(`unkonwType: ${v.type}, data: ${v}`)
            }
          })
          this.loading = false
          if (topics[0].reanswer === false) {
            this.showAnswers()
          } else {
            this.fire()
          }
        }
      }
    }
  },
  mounted () {
    if (this.current) {
      this.mapTopics()
    }
  },
  watch: {
    current () {
      this.mapTopics()
    }
  }
}
</script>

<style lang="scss">
.c-study-topic{
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  min-height: 100%;
  .c-study-topic-content{
    .c-study-topic-title{
      margin: 0 auto;
      line-height: 30px;
      font-size: 22px;
      color: #222427;
      margin-bottom: 25px;
      font-weight: 700;
    }
    button{
      float: right;
      background-color: #29C23D;
      border-radius: 23px;
      width: 120px;
      height: 38px;
      line-height: 38px;
      color: white;
      border: none;
      margin-bottom: 75px;
      outline: none;
    }
  }
  .c-study-topic-fraction{
    position: absolute;
    top: 0;
    right: 0;
    color: #AAABAC;
    font-size: 16px;
    line-height: 60px;
    font-weight: 400;
    span{
      vertical-align: baseline;
    }
    .green{
      color: #29C23D
    }
    .big{
      font-size: 46px;
      line-height: 60px;
    }
  }
  .c-study-topic-loading{
    margin-top: -65px;
  }
}
@media screen and (max-width: 1265px){
  .c-study-topic{
    width: 80%;
  }
}
@media screen and (max-width: 768px){
  .c-study-topic{
    width: 100%;
    padding: 15px;
    box-sizing: border-box;
    .c-study-topic-content{
      .c-study-topic-title{
        margin: 0 auto;
        line-height: 30px;
        font-size: 22px;
        color: #222427;
        margin-bottom: 35px;
        font-weight: 700;
      }
      button{
        width: 200px;
        height: 38px;
        line-height: 38px;
        font-size: 16px;
        color: white;
        margin: 0 auto;
        display: block;
        margin-bottom: 45px;
        float: none;
      }
    }
    .c-study-topic-fraction{
      position: absolute;
      top: 35px;
      right: 15px;
      color: #AAABAC;
      font-size: 12px;
      line-height: 42px;
      font-weight: 400;
      span{
        vertical-align: baseline;
      }
      .green{
        color: #29C23D
      }
      .big{
        font-size: 32px;
        line-height: 42px;
      }
    }
    .c-study-topic-loading{
      margin-top: -65px;
    }
  }
}
</style>
